import React, {Fragment} from 'react';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import {Redirect} from "react-router";
import {withTranslation} from 'react-i18next';
import BaseElectronicSign from "./BaseElectronicSign";

class MSign extends BaseElectronicSign {
    constructor(props) {
        super(props);

        this.get_token_url = this.getTokenUrl(props);
        this.get_token_status_url = this.getTokenStatusUrl(props);

        this.startPingingForLogin = this.startPingingForLogin.bind(this);
        this.startSign = this.startSign.bind(this);
        this.waitingResult = this.waitingResult.bind(this);

        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.mobileAuth = true;
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (this.props.phone !== null && !this.state.phoneNumberInitialized) {
    //         this.setState({
    //             data: {
    //                 phone: this.props.phone
    //             },
    //             phoneNumberInitialized: true,
    //         });
    //     }
    // }

    getTokenUrl(props) {
        if (props.application_token !== undefined) {
            return '/api/process/' + props.application_token + '/sign/msign/token';
        } else if (props.file_token !== undefined) {
            return '/api/remote_sign/' + props.file_token + '/msign/token';
        }

        return null
    }

    getTokenStatusUrl(props) {
        if (props.application_token !== undefined) {
            return '/api/process/' + props.application_token + '/sign/msign/status';
        } else if (props.file_token !== undefined) {
            return '/api/remote_sign/' + props.file_token + '/msign/status';
        }

        return null
    }

    setPhoneNumber(event) {
        this.setState({
            data: {
                phone: event.target.value
            }
        });
    }

    renderForm(props) {
        return (
            <Form>
                <div className="form-group col-12 justify-content-center">
                    <label htmlFor="phone">{this.props.t('forms.phone')}</label>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">+370</div>
                        </div>
                        <Field
                            type="text"
                            name="phone"
                            id="phone"
                            className={'form-control' + (props.errors.phone && props.touched.phone ? ' is-invalid' : '')}
                            onChange={this.setPhoneNumber}
                            value={this.state.data.phone}
                        />
                    </div>
                    <ErrorMessage name="phone" component="div" className="invalid-feedback definitely-show"/>
                </div>
                <div className="form-group col-12 d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary btn-lg" disabled={props.isSubmitting}>
                        {this.props.t('forms.sign.msign')}
                    </button>
                </div>
                {/* NOTE: Formik errors (used in mobile-id) */}
                {props.status && props.status.msg && props.status.code && props.status.code !== 422 ?
                    <div className="col-12 d-flex justify-content-center mt-3">
                        <p>
                            {props.status.msg}
                        </p>
                    </div> : ''}
                {/* NOTE: fallback for errors output (state) */}
                {this.state.error_msg.length > 0 ? <div className="col-12 d-flex justify-content-center mt-3">
                    <p>
                        {this.state.error_msg}
                    </p>
                </div> : ''}
            </Form>
        );
    }

    render() {
        return (
            <div>
                {!this.state.hasCode ?
                    <Fragment>
                        <Formik
                            initialValues={this.state.data}
                            onSubmit={this.startSign}
                            render={this.renderForm}
                        />
                    </Fragment>
                    : <Fragment>{this.waitingResult()}</Fragment>
                }
            </div>
        );
    };

}

export default withTranslation()(MSign);
